import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {AssetSchema} from './asset'

export const AnimatedVideoSchema = buildEntrySchemaFor('animatedVideo', {
  fields: z.lazy(() =>
    z.object({
      video: AssetSchema,
      playLabel: z.string(),
      pauseLabel: z.string(),
      replayLabel: z.string(),
    }),
  ),
})

export type AnimatedVideo = z.infer<typeof AnimatedVideoSchema>
